<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />


        <hr />

        <div>
            <div class="form-inline">
                <label class="sr-only" for="ruleComp">Name</label>
                <select id="ruleComp" class="form-control form-control-sm mb-2 mr-sm-4" v-model="selectedRuleComp">
                    <option :value="null" disabled>Select a Rule...</option>
                    <option v-for="rule in ruleComponentList" :key="rule.label" v-bind:value="rule">
                        {{ rule.label }}
                    </option>
                </select>

                <div class="custom-control custom-checkbox  mb-2 mr-sm-4">
                    <input type="checkbox" class="custom-control-input" id="ruleEnabled" v-model="selectedRuleCompEnabled">
                    <label class="custom-control-label" for="ruleEnabled">Enabled</label>
                </div>
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddRuleClick">Add Rule</button>
            </div>

        </div>

        <hr />

        <data-list :dataCols="pipelineCols"
                   :dataListItems="pipelineRuleList"
                   :tableClass="'table table-striped table-sm'"
                   @sgl-click="handleRuleClick" />

        <hr />

        <div>
            <div class="form-inline">
                <label class="sr-only" for="paramKey">Key</label>
                <input type="text" v-model="ruleParamKey" class="form-control form-control-sm mb-2 mr-sm-2" id="paramKey" placeholder="Key">
                <label class="sr-only" for="paramValue">Value</label>
                <input type="text" v-model="ruleParamValue" class="form-control form-control-sm mb-2 mr-sm-2" id="paramValue" placeholder="Value">
                <button class="btn btn-sm btn-primary mb-2" @click="handleAddRuleParamClick">Add Param</button>
            </div>
        </div>
        <hr />

        <data-list class="mt-3"
                   :dataCols="pipelineParamCols"
                   :dataListItems="ruleParameterList"
                   :tableClass="'table table-striped table-sm'"
                   @sgl-click="handleParamClick"/>
        <hr />
        <div>
            <div class="form-inline">
                <label class="sr-only" for="editParamId">Id</label>
                <input type="text" v-model="editParam.id" class="form-control form-control-sm mb-2 mr-sm-2" id="editParamId" disabled placeholder="Id">
                <label class="sr-only" for="editParamKey">Key</label>
                <input type="text" v-model="editParam.key" class="form-control form-control-sm mb-2 mr-sm-2" id="editParamKey" placeholder="Key">
                <label class="sr-only" for="editParamValue">Value</label>
                <input type="text" v-model="editParam.value" class="form-control form-control-sm mb-2 mr-sm-2" id="editParamValue" placeholder="Value">
                <button class="btn btn-sm btn-primary mb-2" @click="handleUpdateParamClick">Update Param</button>
            </div>
        </div>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

//import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'


//import PageSize from '@/components/PageSize.vue'
//import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { piplineRuleCols, pipelineParamCols } from '@/ui.config/cols/pipelineCols'

import { mapActions } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const editParamEmpty = {
    id: null,
    key: null,
    value: null
    }

export default {
    name:'Pipelines',
    mixins: [

    ],
    components: {
        PageHeader,
        DataList,
        //'data-list-csv': DataListCSV,
        //PageSize,
        //SearchForm,
        Loading,
        //OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Reseller Pipelines - Rules',
            },
            searchInputs: searchInputs,
            pipelineCols: piplineRuleCols,
            pipelineParamCols: pipelineParamCols,



            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ClaimantEmail',
                    label: 'Claimant Email'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Submitted Date'
                },
                {
                    id: 2,
                    key: 'IncidentDate',
                    label: 'incident Date'
                }
            ],

            selectedRuleComp: null,
            selectedRuleCompEnabled: true,
            ruleParamKey: null,
            ruleParamValue: null,
            editParam: editParamEmpty
        }
    },
    beforeMount() {
        let { pipelineId } = this.$store.getters.selectedResellerPipeline
        this.fetchPipelineRules({ pipelineId : pipelineId})
        this.fetchResellers()
        this.fetchIncidentTypes()
        this.fetchRuleComponents()
        this.setSelectedRule(null)
        this.$store.commit('setRuleParameters', null)
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        searchInputsEx() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (resellers) {
                searchInputs[0].options = resellers
            }

            if (incidentTypes) {
                searchInputs[5].options = incidentTypes
            }

            return searchInputs
        },
        resellerPipelineList() {
            return this.$store.getters.resellerPipelineList
        },
        selectedResellerPipeline() {
            return this.$store.getters.selectedResellerPipeline
        },
        pipelineRuleList() {
            return this.$store.getters.pipelineRuleList
        },
        selectedPipelineRule() {
            return this.$store.getters.selectedPipelineRule
        },
        ruleParameterList() {
            return this.$store.getters.ruleParameterList
        },
        ruleComponentList() {
            return this.$store.getters.ruleComponents
        }
    },
    methods: {
        ...mapActions([
            'fetchPipelines',
            'fetchPipelineRules',
            'fetchResellers',
            'fetchIncidentTypes',
            'setSelectedRule',
            'fetchRuleParameters',
            'fetchRuleComponents',
            'addPipelineRule',
            'addRuleParameter',
            'updateRuleParameter'
        ]),
        handleItemDblClick(payload) {
            this.setSelectedRule(payload)
            let { ruleId } = payload
            let { id } = this.selectedResellerPipeline
            this.fetchRuleParameters({ resellerPipelineId: id, ruleId })
        },
        handleRuleClick(payload) {
            this.setSelectedRule(payload[0])
            let { ruleId } = payload[0]
            let { id } = this.selectedResellerPipeline
            this.fetchRuleParameters({ resellerPipelineId: id, ruleId })
        },
        handleAddRuleClick() {
            let { id } = this.selectedRuleComp
            let { pipelineId } = this.selectedResellerPipeline
            this.addPipelineRule({ ruleId: id, pipelineId })
        },
        handleAddRuleParamClick() {
            let { id: pipelineRuleId, ruleId } = this.selectedPipelineRule
            let { id: resellerPipelineId } = this.selectedResellerPipeline
            let { ruleParamKey: key, ruleParamValue: value} = this
            this.addRuleParameter({ ruleId, resellerPipelineId, pipelineRuleId, key, value })
        },
        handleParamClick(payload) {
            let { id, key, value } = payload[0]
            this.editParam = { id, key, value }
        },
        handleUpdateParamClick() {
            let { id, key, value } = this.editParam
            if (id && key && value) {
                this.updateRuleParameter(this.editParam)
                this.editParam = editParamEmpty
            }
        }
    }
}
</script>

<style>
</style>
